import type { ProductId } from './api';

export interface ProductDocumentMetadata {
  title: string;
  description: string;
}

const PRODUCT_SYSTEM_NAMES: Record<ProductId, string> = {
  bos: 'Business Operating System',
  hos: 'Home Operating System',
};

export function productDocumentMetadata(
  product: ProductId,
  productName: string,
): ProductDocumentMetadata {
  const acronym = product.toUpperCase();
  const systemName = PRODUCT_SYSTEM_NAMES[product];
  const name = productName.trim();
  const hasChosenName = name.length > 0 && name.toUpperCase() !== acronym;
  const lockup = hasChosenName ? `${acronym} - ${name}` : acronym;

  return {
    title: `${lockup} | ${systemName}`,
    description: `${hasChosenName ? name : acronym} — ${systemName}`,
  };
}

export function applyProductDocumentMetadata(
  target: Document,
  product: ProductId,
  productName: string,
): ProductDocumentMetadata {
  const metadata = productDocumentMetadata(product, productName);
  target.title = metadata.title;

  let description = target.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (!description) {
    description = target.createElement('meta');
    description.name = 'description';
    target.head.appendChild(description);
  }
  description.content = metadata.description;

  return metadata;
}
